export const learningMapFormats = [
  {
    "id": "5ec5867a0c88fe5860961943",
    "name": "CBSE Learning Maps"
  },
  {
    "id": "5f06b0309a10ea4cb3b9a848",
    "name": "Uttar Pradesh Board Learning Map"
  },
  // {
  //   "id": "65c23151160946735108fd91",
  //   "name": "NGSS"
  // },
  // {
  //   "id": "65c239927439c9929599a94f",
  //   "name": "Common Core"
  // },
  // {
  //   "id": "64d34fc0c6c0fb90e2c71a56",
  //   "name": "Gradeless Learning"
  // },
  {
    "id": "5f4b2677fec0d9f697798bff",
    "name": "Bihar State Board Learning Map"
  },
  {
    "id": "5ef30dcce52bc182d359ccfd",
    "name": "Maharashtra Board Learning Map"
  },
  {
    "id": "5ff40478d7cd5479cd138e5f",
    "name": "West Bengal Board Learning Map"
  },
  {
    "id": "5ef2ff88e52bc182d359b8f7",
    "name": "Rajasthan Board Learning Map"
  },
  {
    "id": "608ab364804d7ea1ab8f1cc9",
    "name": "Madhya Pradesh Board Learning Map"
  },
  {
    "id": "5f12c93e7f10acd6461e5080",
    "name": "Karnataka Board Learning Map"
  },
  {
    "id": "5f0602449a10ea4cb3b91bbd",
    "name": "Tamil Nadu Board Learning Map"
  },
  {
    "id": "6059e603b8fe1c35d0a67db0",
    "name": "Gujarat Board Learning Map"
  },
  {
    "id": "5ff3fc802d1db4012aa090ce",
    "name": "Andhra Pradesh Board Learning Map"
  },
  {
    "id": "608ab337774ebe4e3a0c21c4",
    "name": "Jharkhand Board Learning Map"
  },
  {
    "id": "6059e549b8fe1c35d0a67d72",
    "name": "Assam Board Learning Map"
  },
  {
    "id": "5f12c9997f10acd6461e50e9",
    "name": "Telangana Board Learning Map"
  },
  {
    "id": "6054bac94af3a17785d168b9",
    "name": "Odisha Board Learning Map"
  },
  {
    "id": "608ab2dc8990f4deea1c231b",
    "name": "Haryana Board Learning Map"
  },
  {
    "id": "5ff410033bb906d8743ba6f0",
    "name": "Kerala Board Learning Map"
  },
  {
    "id": "600a82c045b741fb959a180b",
    "name": "Chhattisgarh Board Learning Map"
  },
  {
    "id": "600a585494c5374e85ca86a0",
    "name": "Punjab Board Learning Map"
  },
  {
    "id": "608ab1d5804d7ea1ab8f1cb8",
    "name": "Delhi Board Learning Map"
  },
  {
    "id": "5eef299c420f624a7cd798db",
    "name": "ICSE Learning Map"
  },
  {
    "id": "603de44d956db0e807f48a6e",
    "name": "Uttarakhand Board Learning Map"
  },
  {
    "id": "5faec359329f1db7f7a357f5",
    "name": "Jammu and Kashmir Board Learning Map"
  },
  {
    "id": "608ab30f94638badc7bf984e",
    "name": "Himachal Pradesh Board Learning Map"
  },
  {
    "id": "603de5c934bf1246b9c626fa",
    "name": "Meghalaya Board Learning Map"
  },
  {
    "id": "606ad10b3d96fbb0f3ee070e",
    "name": "Manipur Board Learning Map"
  },
  {
    "id": "608ab3e88990f4deea1c2334",
    "name": "Nagaland Board Learning Map"
  },
  {
    "id": "608be099774ebe4e3a0c3217",
    "name": "Tripura Board Learning Map"
  },
  {
    "id": "608ab2299ae32d0793a79e97",
    "name": "Arunachal Pradesh Board Learning Map"
  },
  {
    "id": "608ab26aaf538c18897a77b7",
    "name": "Goa Board Learning Map"
  },
  {
    "id": "608ab3bf0546e92416e923d0",
    "name": "Mizoram Board Learning Map"
  },
  {
    "id": "60ae36cbedac30b0dd583bc2",
    "name": "Cambridge Board Learning Map"
  },
  {
    "id": "608ab40b94638badc7bf9858",
    "name": "Sikkim Board Learning Map"
  },
  {
    "id": "6087f8c6af538c18897a43ad",
    "name": "IB Board Learning Map"
  },
  {
    "id": "608d74bd804d7ea1ab8f45c3",
    "name": "Ladakh Board Learning map"
  },
  {
    "id": "618a0162616970d13af046ff",
    "name": "NTSE Learning Map"
  },
  {
    "id": "5f17102be61885046e5d9780",
    "name": "Engineering Learning Maps"
  },
  {
    "id": "5f17177ee61885046e5db8d0",
    "name": "Medical Learning Maps"
  },
  {
    "id": "6054b9366042d8dbf764a964",
    "name": "NDA Learning Map"
  },
  {
    "id": "60e5704abfa4221a4a474179",
    "name": "Talent and Scholarship Learning Map"
  },
  {
    "id": "615d3186d8c5ce25acab3ab7",
    "name": "Law Learning Maps"
  },
  {
    "id": "6013d987389ab65a76427236",
    "name": "Science Learning Map"
  },
  {
    "id": "5f52048858ae126dab8a36cd",
    "name": "Embibe Railways Learning Map"
  },
  {
    "id": "5ec586770c88fe586096193e",
    "name": "Banking Learning Maps"
  },
  {
    "id": "5f5207e158ae126dab8a370e",
    "name": "Embibe SSC Learning Map"
  },
  {
    "id": "5fce2026c240c4991ec5e96a",
    "name": "Embibe National Recruitment Agency Learning Map"
  },
  {
    "id": "5f5206b031562a10f6a592ff",
    "name": "Embibe Defence Learning Map"
  },
  {
    "id": "5f520569429ee9ee0e8c1b04",
    "name": "Embibe Insurance Learning Map"
  },
  {
    "id": "5eb7ced0c20bf39d163d763c",
    "name": "Embibe Teaching Learning Map"
  },
  {
    "id": "60abaf50c7d0c0020c95a5a3",
    "name": "Embibe Lectureship Learning Map"
  },
  {
    "id": "615ac9133ba95a1dcda488f2",
    "name": "Embibe Management Learning Map"
  },
  {
    "id": "5ec586830c88fe5860961950",
    "name": "KVPY Learning Maps"
  },
  {
    "id": "5ec586870c88fe5860961956",
    "name": "Management Learning Maps"
  },
  {
    "id": "5ec5868a0c88fe586096195a",
    "name": "NTSE Learning Maps"
  },
  {
    "id": "5ec5868b0c88fe586096195c",
    "name": "Olympiad Learning Maps"
  },
  {
    "id": "5ec5868e0c88fe5860961960",
    "name": "SAT Learning Maps"
  },
  {
    "id": "5ec586900c88fe5860961965",
    "name": "Training Learning Maps"
  },
  {
    "id": "5fffc6f8208e730f9c09ca8b",
    "name": "Embibe Master - Learning Map"
  },
  {
    "id": "5e8b2486af5c4e9f6f296c15",
    "name": "Embibe Learning Maps with Code"
  },
  {
    "id": "5f171296e61885046e5da6a9",
    "name": "JEE Advanced Learning Map"
  },
  {
    "id": "615ab3fa59170eac8c1da963",
    "name": "Embibe UPSC Learning Map"
  },
  {
    "id": "65cb4231954b6dbdd34e9fd7",
    "name": "Final NGSS Learning Map New"
  },
  {
    "id": "65cb431a6c7054effa373540",
    "name": "Final Common Core State Standards Learning Map New"
  },
  {
    "id": "65cb2f8a79ed512df3b299f0",
    "name": "Final Common Core PowerSchool Learning Map"
  },
  {
    "id": "65cb1aeda5f5c89c0aa04252",
    "name": "Final NGSS Power School Learning Map"
  },
  {
    "id": "65cb4231954b6dbdd34e9fd7",
    "name": "Final NGSS Learning Map New"
  },
  {
    "id": "65cb431a6c7054effa373540",
    "name": "Final Common Core State Standards Learning Map New"
  },
  {
    "id": "65cb2f8a79ed512df3b299f0",
    "name": "Final Common Core PowerSchool Learning Map"
  },
  {
    "id": "65cb1aeda5f5c89c0aa04252",
    "name": "Final NGSS Power School Learning Map"
  }
]
